module.exports = "/images/cz.svg?d516bfaad16702516df73f0ff9af20ce";